import type { Observable } from 'rxjs';
import type { CollectionQueryItem, CollectionQueryStateStatuses } from '@common/adapters/collection-query';
import type { EduCoursePaymentEntity } from '@common/types/payment-form.type';
import type { EduCoursePaymentsCollectionState } from './edu-course-payments.reducer';

import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { mergeMap, of } from 'rxjs';

import EduCoursePaymentsActions from './edu-course-payments.actions';
import * as PaymentMethodsSelectors from './edu-course-payments.selectors';

@Injectable()
export class EduCoursePaymentsCollectionFacade {
    private readonly store = inject<Store<EduCoursePaymentsCollectionState>>(Store);

    public loadEduCoursePaymentsCollection(courseId: number): void {
        this.store.dispatch(EduCoursePaymentsActions.loadCollectionRequest({ courseId }));
    }

    public eduCoursePayments$(courseId: number): Observable<EduCoursePaymentEntity[]> {
        if (!courseId) {
            return of([]);
        }

        return this.store.select(PaymentMethodsSelectors.selectEduCoursePayments(courseId.toString())).pipe(
            mergeMap((eduCoursePayments: CollectionQueryItem<EduCoursePaymentEntity[]>) => {
                if (!eduCoursePayments) {
                    this.loadEduCoursePaymentsCollection(courseId);
                    return of([]);
                }

                return of(eduCoursePayments.item || []);
            })
        );
    }

    public eduCoursePaymentsStatuses$(courseId: number): Observable<CollectionQueryStateStatuses> {
        if (!courseId) {
            return of({} as any);
        }

        return this.store.select(PaymentMethodsSelectors.selectEduCoursePaymentsStatuses(courseId.toString()));
    }
}
